import React from 'react'
import { Spinner } from 'components/lib/loaders'
import { colors } from 'config/ui'
import { Wrapper } from './SpinnerLoader.styles'

const SpinnerLoader: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { size?: string }
> = ({ color, size, ...props }) => (
  <Wrapper {...props}>
    <Spinner color={color ? color : colors.primary} size={size} />
  </Wrapper>
)

export default SpinnerLoader
